var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a{fill:none;stroke:#d1ed5d;stroke-miterlimit:10;}")),React.createElement("path",{"className":"a","d":"M120.86,73.7,105.42,57.78,71.68,92.31V.88H49.88V92.31L16.15,57.78.7,73.7l60.08,61.35Z","key":1})]);
}

Arrow.defaultProps = {"viewBox":"0 0 121.58 136.15"};

module.exports = Arrow;

Arrow.default = Arrow;
